import { render, staticRenderFns } from "./botProfileAbout.vue?vue&type=template&id=11a84c64&"
import script from "./botProfileAbout.vue?vue&type=script&lang=js&"
export * from "./botProfileAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports